export default "/img/ER.1aa00bb907a25f225abcdcda0a4e2644.png";